"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayPositioner = exports.FillScreen = exports.HeaderInlineTitleTextContainer = exports.HeaderInlineTitleContainer = exports.TitleTextContainer = exports.ModalInlineCloseButtonContainer = exports.ModalCloseButtonContainer = exports.StickyTitle = exports.HeaderImageWrapper = exports.ModalFooterContainer = exports.LayeredFooterContainer = exports.InContentModalFooterContainer = exports.FixedModalFooterContainer = exports.ModalFooter = exports.ModalContent = exports.ModalContentContainer = exports.ModalStickyHeader = exports.HeaderTextContainer = exports.ModalHeaderInset = exports.ModalContentHeader = exports.ModalInset = exports.ModalContainer = void 0;

var _designLanguage = require("@doordash/design-language");

var _constants = require("./constants");

var _componentLayerManager = require("@doordash/component-layer-manager");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _getEnvironmentConstants = require("./getEnvironmentConstants");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MOBILE_MODAL_PADDING = _constants.ContentPadding.Mobile;
var OS = (0, _getEnvironmentConstants.getMobileDevice)(); // Because the Title size for Modal is
// Themeable/adjustable, this minimum height
// is set on the close button container and
// around the title `Text` container
// to ensure that they are correctly aligned
// when they're displayed inline
// It's set to 40 as that is the default
// height and width set on a Prism `IconButton`

var TITLE_MIN_SIZE = 40;

var getMobileHeight = function getMobileHeight() {
  // If we're on Android, we need to account for
  // the URL Bar Resizing behavior that's described
  // here: https://developers.google.com/web/updates/2016/12/url-bar-resizing
  // We're relying on the fact that position: fixed
  // elements have an exception in that it will
  // always fill the visible height, even if the URL bar
  // is showing or hiding.
  if (OS === 'Android') {
    return '100%';
  } // By default, just take up the entire viewport height.


  return '100vh';
};

var MOBILE_HEIGHT = getMobileHeight();

var getMaxWidthForSize = function getMaxWidthForSize(props) {
  if (props.size === _constants.Sizes.Custom && (0, _lodash.get)(props.customSize, 'maxWidth')) {
    return "".concat(props.customSize.maxWidth, "px");
  }

  if (props.size === _constants.Sizes.FullScreen) {
    return "100vw";
  }

  if (props.modalWidth) {
    return "".concat(props.modalWidth, "px");
  }

  return "".concat(_constants.BreakpointModalWidths.Desktop[_constants.Sizes.Large], "px");
};

var getHeightForSize = function getHeightForSize(props) {
  switch (props.size) {
    case _constants.Sizes.FullScreen:
      return '100vh';

    default:
      return '0';
  }
};

var getMaxHeightForSize = function getMaxHeightForSize(props) {
  if (props.isFooterFixedPosition && OS === 'iOS') {
    // To properly handle any changes to the "available" real estate
    // on the screen with iOS Safari address & navigation bar expand
    // and collapse behavior and keep the overlay spacing around tablet
    // Modals. This logic "shrinks" the ModalContainer to be just behind
    // the top line of the fixed footer container, so that the Modal appears
    // to be a seamless unit while still preserving the padding on all sides
    return "calc(".concat(props.viewportHeight, "px - ").concat(props.modalPadding * 2, "px - ").concat(props.bottomLocation + props.modalPadding * 2, "px)");
  }

  var defaultMaxHeight = props.viewportHeight - props.modalPadding * 2;

  if (props.size === _constants.Sizes.Custom && (0, _lodash.get)(props.customSize, 'maxHeight') && props.customSize.maxHeight <= defaultMaxHeight) {
    return "".concat(props.customSize.maxHeight, "px");
  }

  return "calc(100vh - ".concat(props.modalPadding * 2, "px)");
};

var getBorderRadiusForSize = function getBorderRadiusForSize(props) {
  switch (props.size) {
    case _constants.Sizes.FullScreen:
      return '0px';

    default:
      return "".concat(props.modalBorderRadius, "px");
  }
};

var ModalContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  background: ", ";\n  box-shadow: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  max-width: ", ";\n  width: calc(100vw - ", "px);\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  -ms-overflow-y: scroll;\n  bottom: ", "px;\n  ", ";\n"])), function (props) {
  return props.modalBackgroundColor;
}, _designLanguage.Shadows.Large, getHeightForSize, getMaxHeightForSize, getMaxWidthForSize, function (props) {
  return props.modalPadding * 2;
}, getBorderRadiusForSize, function (props) {
  return props.isFooterFixedPosition && OS === 'iOS' ? props.bottomLocation > 0 ? props.bottomLocation : props.modalPadding * 2 : 0;
}, _designLanguage.Media.Mobile(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    max-width: ", ";\n    max-height: 100%;\n    height: ", ";\n    top: 0;\n    border-radius: ", ";\n    width: 100vw;\n    padding-bottom: ", ";\n  "])), function (props) {
  return props.isFullScreenOnMobile ? 'none' : "calc(100vw - ".concat(MOBILE_MODAL_PADDING, "px)");
}, function (props) {
  return props.isFullScreenOnMobile ? MOBILE_HEIGHT : 'auto';
}, function (props) {
  return props.isFullScreenOnMobile ? _designLanguage.BorderRadius.None : getBorderRadiusForSize(props);
}, function (props) {
  return (// The addition of bottom padding for fixed footers on Mobile
    // ensures the user is able to scroll and that none of the content
    // is inadvertently hidden behind the fixed footer on the other layer
    props.isFullScreenOnMobile && props.isFooterFixedPosition ? "".concat(props.fullscreenMobileBottomPadding, "px") : undefined
  );
}));

exports.ModalContainer = ModalContainer;

var showDivider = function showDivider(side) {
  return function (props) {
    return props.showDivider ? (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          box-shadow: 0px calc(", " * 1px) 15px rgba(0, 0, 0, 0.2);\n        "])), side === 'top' ? -1 : 1) : (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          box-shadow: 0px calc(", " * 1px) 0px rgba(0, 0, 0, 0);\n        "])), side === 'top' ? -1 : 1);
  };
};

var ConfiguredInset = function ConfiguredInset(_ref) {
  var hasPadding = _ref.hasPadding,
      modalPadding = _ref.modalPadding,
      props = _objectWithoutProperties(_ref, ["hasPadding", "modalPadding"]);

  return /*#__PURE__*/_react["default"].createElement(_designLanguage.Inset, _extends({
    size: hasPadding ? modalPadding : _designLanguage.Inset.Sizes.None
  }, props));
};

ConfiguredInset.propTypes = {
  hasPadding: _propTypes["default"].bool,
  modalPadding: _propTypes["default"].number
};
var ModalInset = (0, _styledComponents["default"])(ConfiguredInset)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n"])), _designLanguage.Media.Mobile(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding: ", "px ", "px;\n  "])), function (props) {
  return props.hasPadding ? MOBILE_MODAL_PADDING / 2 : 0;
}, function (props) {
  return props.hasPadding ? MOBILE_MODAL_PADDING : 0;
}));
exports.ModalInset = ModalInset;
ModalInset.defaultProps = {
  hasPadding: true
};

var ModalContentHeader = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  text-align: ", ";\n"])), function (props) {
  return props.headerAlignment;
}); // When there's no modal content, we want
// to have no padding on the bottom of the header


exports.ModalContentHeader = ModalContentHeader;
var ModalHeaderInset = (0, _styledComponents["default"])(ModalInset).attrs({
  isSquished: true
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (props) {
  return !props.hasContent && (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      padding-bottom: 0px;\n    "])));
});
exports.ModalHeaderInset = ModalHeaderInset;

var HeaderTextContainer = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding: ", "px;\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n"])), function (props) {
  return props.hasContentPadding ? props.modalPadding : _designLanguage.Spacing.None;
}, function (props) {
  return props.hasCloseButton && !props.hasHeaderImage ? _designLanguage.Spacing.None : props.modalPadding;
}, function (props) {
  return props.hasContent ? props.modalPadding : _designLanguage.Spacing.None;
});

exports.HeaderTextContainer = HeaderTextContainer;
var ModalStickyHeader = (0, _designLanguage.withTheming)(_styledComponents["default"].div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  background: ", ";\n  padding: ", "px;\n  border-radius: ", ";\n  border-bottom: 1px solid ", ";\n  transition: all 0.2s ease-in-out;\n  z-index: 1;\n  ", ";\n  ", ";\n"])), function (props) {
  return props.modalBackgroundColor;
}, function (props) {
  return props.modalPadding - _designLanguage.Spacing.Small;
}, function (props) {
  return "".concat(props.modalBorderRadius, "px ").concat(props.modalBorderRadius, "px 0 0");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.Colors.BorderPrimary;
}, showDivider('bottom'), _designLanguage.Media.Mobile(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    border-radius: ", ";\n  "])), function (props) {
  return props.isFullScreenOnMobile && _designLanguage.BorderRadius.None;
}))); // This uses a div instead of `styled(ModalInset)`
// to make it easier to set the ref for the component

exports.ModalStickyHeader = ModalStickyHeader;

var ModalContentContainer = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  z-index: 0;\n  ", ";\n"])), function (props) {
  return !props.hasFooter && props.hasPadding && (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      padding-bottom: ", "px;\n    "])), props.modalPadding);
});

exports.ModalContentContainer = ModalContentContainer;
var ModalContent = (0, _styledComponents["default"])(ModalInset).attrs({
  size: function size(props) {
    return props.hasPadding ? props.modalPadding : _designLanguage.Inset.Sizes.None;
  },
  isSquished: true
})(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  padding-top: 0;\n"])));
exports.ModalContent = ModalContent;

var ModalFooter = _styledComponents["default"].div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: ", "px;\n  border-radius: ", ";\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: 'row';\n  ", ";\n  flex-shrink: 0;\n  overflow: hidden;\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  return props.modalBackgroundColor;
}, function (props) {
  return props.modalPadding;
}, function (props) {
  return "0 0 ".concat(props.modalBorderRadius, "px ").concat(props.modalBorderRadius, "px");
}, function (props) {
  return props.shouldStackButtons && (0, _styledComponents.css)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      flex-direction: column-reverse;\n      & > button:nth-child(2) {\n        margin-bottom: ", "px;\n      }\n    "])), _designLanguage.Spacing.XSmall);
}, function (props) {
  return !props.shouldStackButtons && (0, _styledComponents.css)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      & > button:nth-child(2) {\n        margin-left: ", "px;\n      }\n    "])), props.inlineActionButtonSpacing);
}, showDivider('top'), function (props) {
  return props.actionsFillContainer && (0, _styledComponents.css)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n      & > * {\n        flex-grow: 1;\n        flex-shrink: 1;\n        flex-basis: 50%;\n      }\n    "])));
}, _designLanguage.Media.Mobile(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    padding: ", "px;\n    flex-direction: column-reverse;\n    & > button:nth-child(2) {\n      margin: 0 0 ", "px 0;\n    }\n    border-radius: ", ";\n  "])), MOBILE_MODAL_PADDING, _designLanguage.Spacing.XSmall, function (props) {
  return props.isFullScreenOnMobile && _designLanguage.BorderRadius.None;
}));

exports.ModalFooter = ModalFooter;

var FixedModalFooterContainer = _styledComponents["default"].div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  position: fixed;\n  left: 0;\n  right: 0;\n  margin: auto;\n  bottom: ", "px;\n  max-width: ", ";\n  width: calc(100vw - ", "px);\n  ", ";\n"])), function (props) {
  return props.modalSize === _constants.Sizes.FullScreen ? '0' : props.modalPadding;
}, function (props) {
  return getMaxWidthForSize({
    size: props.modalSize
  });
}, function (props) {
  return props.modalPadding * 2;
}, _designLanguage.Media.Mobile(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    width: 100vw;\n    max-width: ", ";\n    bottom: ", "px;\n  "])), function (props) {
  return props.isFullScreenOnMobile ? 'none' : "calc(100vw - ".concat(MOBILE_MODAL_PADDING, "px)");
}, function (props) {
  return props.isFullScreenOnMobile ? props.mobileBottomLocation : MOBILE_MODAL_PADDING;
}));

exports.FixedModalFooterContainer = FixedModalFooterContainer;

var InContentModalFooterContainer = _styledComponents["default"].div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  z-index: 1;\n  transition: all 0.3s ease-in-out;\n"])));

exports.InContentModalFooterContainer = InContentModalFooterContainer;
var LayeredFooterContainer = (0, _componentLayerManager.renderOnLayer)(_componentLayerManager.Layers.PopoverModal, FixedModalFooterContainer);
exports.LayeredFooterContainer = LayeredFooterContainer;

var ModalFooterContainer = function ModalFooterContainer(_ref3) {
  var isFooterFixedPosition = _ref3.isFooterFixedPosition,
      props = _objectWithoutProperties(_ref3, ["isFooterFixedPosition"]);

  return isFooterFixedPosition && OS === 'iOS' ? /*#__PURE__*/_react["default"].createElement(LayeredFooterContainer, props) : /*#__PURE__*/_react["default"].createElement(InContentModalFooterContainer, props);
};

exports.ModalFooterContainer = ModalFooterContainer;
ModalFooterContainer.propTypes = {
  isFooterFixedPosition: _propTypes["default"].bool
};
ModalFooterContainer.defaultProps = {
  isFooterFixedPosition: false
};

var HeaderImageWrapper = _styledComponents["default"].div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  border-top-left-radius: ", "px;\n  border-top-right-radius: ", "px;\n  flex-shrink: 0;\n  overflow: hidden;\n  text-align: center;\n"])), function (props) {
  return props.modalBorderRadius;
}, function (props) {
  return props.modalBorderRadius;
});

exports.HeaderImageWrapper = HeaderImageWrapper;

var StickyTitle = _styledComponents["default"].div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  overflow: hidden;\n  & > * {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n"])));

exports.StickyTitle = StickyTitle;

var ModalCloseButtonContainer = _styledComponents["default"].div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: ", ";\n  ", ";\n"])), function (props) {
  return props.closeButtonSide === _constants.CloseButtonSides.Trailing ? 'row-reverse' : 'row';
}, function (props) {
  return props.isFloating || props.hasCustomHeader ? (0, _styledComponents.css)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n          ", ";\n          ", ";\n          padding: ", "px;\n        "])), props.isFloating && 'position: absolute', props.isFloating && 'z-index: 1', props.modalPadding - _designLanguage.Spacing.XxSmall) : (0, _styledComponents.css)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n          padding: ", "px;\n          padding-bottom: ", "px;\n        "])), props.modalPadding - _designLanguage.Spacing.XxSmall, _designLanguage.Spacing.XxSmall);
});

exports.ModalCloseButtonContainer = ModalCloseButtonContainer;

var ModalInlineCloseButtonContainer = _styledComponents["default"].div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: ", "px;\n"])), TITLE_MIN_SIZE, TITLE_MIN_SIZE);

exports.ModalInlineCloseButtonContainer = ModalInlineCloseButtonContainer;

var TitleTextContainer = _styledComponents["default"].div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  text-align: ", ";\n  ", ";\n"])), function (props) {
  return props.shouldCenterText ? 'center' : 'flex-start';
}, function (props) {
  return props.shouldCenterText ? 'center' : 'initial';
}, function (props) {
  return props.isInlineTitle && "min-height: ".concat(TITLE_MIN_SIZE, "px");
});

exports.TitleTextContainer = TitleTextContainer;
var HeaderInlineTitleContainer = (0, _styledComponents["default"])(_designLanguage.InlineChildren).attrs({
  justifyContent: _designLanguage.InlineChildren.Justification.SpaceBetween,
  size: function size(props) {
    return props.modalPadding;
  }
})(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  padding-right: ", "px;\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  padding-top: ", "px;\n"])), function (props) {
  return props.hasPadding ? props.hasCloseButton ? props.modalPadding - _designLanguage.Spacing.XxSmall : props.modalPadding : 0;
}, function (props) {
  return props.hasPadding ? props.hasCloseButton && props.isCenterAligned ? props.modalPadding - _designLanguage.Spacing.XxSmall + TITLE_MIN_SIZE + props.modalPadding : props.modalPadding : 0;
}, function (props) {
  return props.hasPadding ? props.modalPadding - _designLanguage.Spacing.XxSmall : 0;
}, function (props) {
  return props.hasPadding ? props.hasHeaderImage ? props.modalPadding : props.modalPadding - _designLanguage.Spacing.XxSmall : 0;
});
exports.HeaderInlineTitleContainer = HeaderInlineTitleContainer;
var HeaderInlineTitleTextContainer = (0, _styledComponents["default"])(_designLanguage.StackChildren)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
exports.HeaderInlineTitleTextContainer = HeaderInlineTitleTextContainer;

var FillScreen = _styledComponents["default"].div(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  z-index: 1;\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", ";\n  pointer-events: none;\n  & > * {\n    pointer-events: auto;\n  }\n"])), _designLanguage.Media.Mobile(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n    height: ", ";\n  "])), MOBILE_HEIGHT));

exports.FillScreen = FillScreen;

var OverlayPositioner = _styledComponents["default"].div(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n"])));

exports.OverlayPositioner = OverlayPositioner;